type TPageType = 'standard' | 'focus' | 'process'
export type TPageBackground = 'gradient' | 'primary-light' | 'white'

const PAGE_TYPE_CONFIG: Record<TPageType, { background: TPageBackground; showBanners: boolean }> = {
  standard: {
    background: 'gradient',
    showBanners: true,
  },
  focus: {
    background: 'primary-light',
    showBanners: false,
  },
  process: {
    background: 'white',
    showBanners: false,
  },
}

/**
 * Most-specific patterns first. Unmatched paths default to `standard`.
 * Patterns are matched against expo-router `usePathname()` (no query string).
 */
const PAGE_TYPE_ROUTES: { match: RegExp; type: TPageType }[] = [
  // process — settings / auth / publications
  { match: /^\/settings\/account(\/$|$)/, type: 'process' },
  { match: /^\/settings\/account\/avatars\/[0-9]+$/, type: 'process' },
  { match: /^\/auth(\/|$)/, type: 'process' },
  { match: /^\/publications\/[^/]+\/?$/, type: 'process' },

  // focus —  join funnel /immersive / prayer / forms / rewards
  { match: /^\/community\/[^/]+\/join(\/|$)/, type: 'focus' },
  { match: /^\/preferences(\/|$)/, type: 'focus' },
  { match: /\/pray(\/|$)/, type: 'focus' },
  { match: /\/reward(\/|$)/, type: 'focus' },
  { match: /^\/intention\/create(\/|$)/, type: 'focus' },
  { match: /^\/intention\/[^/]+\/prayers(\/|$)/, type: 'focus' },

  // /watchman/intentions stays standard (browsing list with banners)
  { match: /^\/watchman\/?$/, type: 'focus' },
  { match: /^\/rosario(\/|$)/, type: 'focus' },
  { match: /^\/leave(\/|$)/, type: 'focus' },
  { match: /^\/page(\/|$)/, type: 'focus' },
]

export const resolvePageType = (pathname: string): TPageType =>
  PAGE_TYPE_ROUTES.find(({ match }) => match.test(pathname))?.type ?? 'standard'

export const getPageTypeConfig = (pathname: string) => PAGE_TYPE_CONFIG[resolvePageType(pathname)]
